type ApiResponseType = ApiSchema['ListingResponse'];
interface ParamsType { }

/**
 * Loads listing details for a specific listingId
 */
export default async function apiLoadListing<T extends Listing>(listingId: string | undefined): Promise<ApiResult<T>> {
    try {
        return await callApiGet<T, ApiResponseType, ParamsType>(
            `/listings/${listingId}`,

            // Request body
            {},

            // Transform result
            (response: ApiResponseType): T => {
                return transformListing(response.listing) as T;
            },
        );
    }
    catch (error) {
        throw new Error('Failed to load single listing', { cause: error });
    }
}
